import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Space, Typography } from 'antd'

import { getShopifyBaseUrl, } from 'src/utils/helper'
import { faqPage } from 'src/routes/NamedRoutes'

const HelpSection = (): ReactElement => {
  const { t } = useTranslation()
  const baseUrlShopify = getShopifyBaseUrl()
  return (
    <Space direction="vertical">
      <Typography.Title level={3}>
        {t('common:footer.sections.help')}
      </Typography.Title>
      <a href={`${baseUrlShopify}/pages/find-frames-that-fit`}>
        {t('common:footer.help.shopping')}
      </a>
      <a href={`${baseUrlShopify}/pages/help`}>
        {t('common:footer.help.website')}
      </a>
      <a href={`${baseUrlShopify}/pages/help#shopify-section-help-status`}>
        {t('common:footer.help.your_order')}
      </a>
      <a href={faqPage}>
        {t('common:footer.help.faq')}
      </a>
    </Space>
  )
}

export default HelpSection
